import { JsonFetchResponse, SuggestionsResponse, useSuggestionsFetch as useSuggestionsFetchCore } from "@xapp/chat-widget-core";
import { useWidgetEnv } from "../config";

export function useSuggestionsFetch(search: string, context: readonly string[] | undefined): JsonFetchResponse<SuggestionsResponse> {

    const env = useWidgetEnv();

    const baseUrl = env?.autocompleteSuggestionsUrl;

    return useSuggestionsFetchCore({
        url: baseUrl,
        query: search,
        context
    });
}